// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-answer-link[data-v-641474c4] {\r\n  display: block;\r\n  color: white;\n}\n.default-answer-link[data-v-641474c4] {\r\n  display: block;\r\n  color: white;\r\n  margin: 5px 0 5px 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
